import React, { Component } from 'react';
import axios from 'axios'
import { base, pythonApiIp, firebaseStorage, whatsapp_api_glassfish } from '../../../../config/constants'
import FileUploader from 'react-firebase-file-uploader';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form, Image } from 'semantic-ui-react'
import * as moment from 'moment';
//import { base, serverIp, getOrderKey, toCurrency, pythonApiIp } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants.js'
import ImageUploader from '../../../newSite/ImageUploader'

export class WhatsappClientRejected extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_num: '',
            rejectMssage: '',
            phone: this.props.phone,
            loading: false,
            visible: false,
            docUrl: false,
            imageUrl: 'none'
        }
    }

    sentToClientRejected = () => {

        if (this.state.order_num == '' || this.state.order_num.length != 5) {
            alert("no order num or invalid order num")
        } else if (this.state.rejectMssage == '' || this.state.rejectMssage.length < 3) {
            alert("reject message empty or too short must be longer that 3 charge")
        } else if (!this.props.phone) {
            alert("no phone number")
        } else {

            this.setState({ loading: true })

            var d = new Date();
            let now = moment().format('MMMM Do, h:mm:ss a');

            // REPLACE_PYTHON_API
            // pythonApiIp
            // whatsapp_api_glassfish

            axios.post(whatsapp_api_glassfish + 'sentToClientRejected', {
                apiKey: "printb_dash_sentToClientRejected",
                order_num: parseInt(this.state.order_num),
                rejectMssage: this.state.rejectMssage,
                phone: this.props.phone,
                enteredBy: "info@printboda.com",
                imageUrl: this.state.imageUrl
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if (response.data.result) {
                        this.setState({ loading: false })
                        console.log(response);

                        if (response.data.result) {
                            console.log(" sent");
                            alert(response.data.message)

                            this.setState({
                                order_num: '',
                                rejectMssage: '',
                            })
                        }
                    } else {
                        console.log("FAILED");
                        alert("FAILED TO sent:" + response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });

        }



    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    showUI = () => {
        console.log("setVisible")

        if (this.state.visible) {
            console.log("state is " + this.state.visible)
            this.setState({
                visible: false
            })
        } else if (!this.state.visible) {
            console.log("state is " + this.state.visible)
            this.setState({
                visible: true
            })
        }
    }

    /**
   * HANDLE THE FILE UPLOADING..
   */
    handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }

    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('clientRejectedImages').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };


    // updateWhenFileUploadComplete = (uploaded, fileName, url) => {
    //     console.log("docx17 +++++++: updateWhenFileUploadComplete");
    //     console.log("docx181 uploaded:" + uploaded);
    //     console.log("docx18 fileName:" + fileName);
    //     console.log("docx19 url:" + url)
    // }

    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url
        });
    }


    render() {

        const sendButton = this.state.order_num.length == 5 && this.state.rejectMssage.length > 3
            ? <Button color='green' onClick={this.setDepPaid}> SEND to client rejected </Button>
            : ''

        // const fileUploadUI = <div>
        //     <h4>IMAGE LINK: {this.state.docUrl}</h4>
        //     <FileUploader
        //         accept="image/*,"
        //         name="avatar"
        //         filename={this.props.fileName}
        //         //storageRef={firebaseStorage.ref('orderDesigns/')}
        //         storageRef={firebaseStorage.ref('clientRejectedImages')}
        //         onUploadStart={this.handleUploadStart}
        //         onUploadSuccess={this.handleUploadSuccess}
        //         onProgress={this.handleProgress}
        //     />
        // </div>

        const imagePreview = this.state.imageUrl != 'none'
            ? (<Image src={this.state.imageUrl} size='small' fluid />)
            : (<p></p>)

        const fileUploadUI = <div>
            <label>Upload Image</label>
            <ImageUploader
                updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                storageReference={'clientRejectedImages'} />
            {imagePreview}
        </div>




        const wholeUi = this.state.visible
            ? <Form onSubmit={this.sentToClientRejected}>

                <label>Order Number:{this.state.order_num}</label>
                <Form.Input
                    fluid
                    icon='hashtag'
                    iconPosition='left'
                    placeholder='Order Number'
                    type='number'
                    name="order_num"
                    value={this.state.order_num}
                    onChange={this.handleTextInputChange}
                />

                <label>Reject rejectMssage{this.state.rejectMssage}</label>
                <Form.Input
                    fluid
                    icon='money'
                    iconPosition='left'
                    placeholder='Reject Reason'
                    type='text'
                    name="rejectMssage"
                    value={this.state.rejectMssage}
                    onChange={this.handleTextInputChange}
                />

                {fileUploadUI}

                {sendButton}
            </Form>
            : ""

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Divider horizontal>{'CLIENT REJECTED'}</Divider>
                <Button color='red' onClick={this.showUI} fluid>Client Rejected</Button>
                {wholeUi}

            </div>
        )
    }
}

export default WhatsappClientRejected;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappClientRejected.js